import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { Option } from '@b2b/features/product/core/utilities/product-list.model';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'sort',
  imports: [CommonModule, TranslateModule],
  templateUrl: './sort.component.html',
  styleUrl: './sort.component.scss',
})
export class SortComponent implements OnInit {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  options$ = new BehaviorSubject<Option[]>([
    {
      code: 'score',
      label: 'Relevância',
    },
    {
      code: 'MAKTX_asc',
      label: 'Nome - Ascendente',
    },
    {
      code: 'MAKTX_desc',
      label: 'Nome - Descendente',
    },
  ]);
  selectedOption = this.options$.value[0];

  ngOnInit() {
    const currentQuery = this.activatedRoute.snapshot.queryParams['query'] || '*:score';
    const orderValue = currentQuery.split(/['&:']/)[1];

    this.selectedOption = this.options$.value.find(option => option.code === orderValue) || this.options$.value[0];
  }

  handlerChangeOrder(event: Event) {
    const currentQuery = this.activatedRoute.snapshot.queryParams['query'] || '*:score';
    const valueEvent = (event.currentTarget as HTMLSelectElement)?.value;
    const currentValue = currentQuery.split(/['&:']/)[1];

    const newUrl = currentQuery.replace(':' + currentValue, ':' + valueEvent);

    this.changeParamOnUrl(newUrl);
  }

  changeParamOnUrl(queryParams: Params | null) {
    this.router.navigate([], {
      queryParams: {
        ['query']: queryParams,
        ['page']: 1,
      },
      queryParamsHandling: 'replace',
      replaceUrl: true,
    });
  }
}
